import { useEffect, useMemo, useState } from "react";
import { useGoHome } from "../../../utils/navigations/useGoHome";
import { useSelector } from "react-redux";
import { isBusinessLocked } from "../../../utils/isBusinessLocked";

const useWorkspaceLockPopup = () => {
    const { goHome } = useGoHome();
    
    // ------
    // Redux
    // ------
    const { current_organization } = useSelector(state => state.organization);

    // ------
    // States
    // ------
    const [show , setShow] = useState(false);

    // ------
    // Functions
    // ------
    const handleClose = () => {
        setShow(false);
        goHome();
    }

    // ------
    // Effects
    // ------
    useEffect(() => {
        if(current_organization){
            const locked = isBusinessLocked(current_organization);
            setShow(locked);
        }
    
    }, [current_organization]);

    // ------
    // Variables
    // ------
    const body_text = useMemo(() => {
        if(current_organization?.owner){
            return 'Heads up! Your Upprovall+ subscription has ended. Please contact support to renew your subscription.';
        } else if (current_organization) {
            return 'This workspace is locked. Please contact admin for assistance.';
        } else {
            return null;
        }
    }, [current_organization]);

    return {
        show,
        handleClose,
        body_text
    }
}

export default useWorkspaceLockPopup
